//@ts-nocheck
import React, { useState, useEffect, useRef } from "react";
import { formatDistanceStrict } from "date-fns";
import { debounce } from "lodash";
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import { _baseRequest, COMMON } from "../../../utils/baseApi";
import { useNavigate, useParams } from "react-router-dom";
import { fetchDepartmentList } from "../../../features/department/departmentSlice";
import { useAppDispatch } from "../../../app/hooks";
import {
  fetchApplicationByListData,
  UpdateJobApplicationByList,
} from "../../../features/ApplicationData/ApplicationDataSlice";
import ApplicationData from "./ApplicationData";
import { toast } from "sonner";
import { fetchDocument } from "../../../features/job/jobSlices";
import { ExclamationIcon } from "../../icons";
import { fetchJobPipelineDetailsData } from "../../../features/pipeline/pipelineSlice";
import LoadingBar from "react-top-loading-bar";

const InboxDetails = [
  { id: "all", name: "All" },
  { id: "message", name: "Message" },
  { id: "file", name: "File" },
  { id: "team", name: "Team" },
  { id: "note", name: "Note" },
];

function Application() {
  const [activeTab, setActiveTab] = useState(null);
  const [activeTab1, setActiveTab1] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [allActivityItem, setAllActivityItem] = useState({
    jobApplication: [],
    totalJobPost: 0,
    currentPage: 1,
    hasNextPage: false,
    limit: 25,
    totalPages: 1,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [shouldLoadMore, setShouldLoadMore] = useState(false);
  const { baseId, jobId, applicationId } = useParams<{
    baseId: string;
    jobId: string;
    applicationId: string;
  }>();
  const listRef = useRef(null);
  const handleMouseOver = () => setIsHovered(true);
  const handleMouseOut = () => setIsHovered(false);
  const [selected, setSelected] = useState(InboxDetails[0]);
  const loginUserId = localStorage.getItem("userAuthId");
  const { jobApplication } = allActivityItem;
  const userDetailsData = localStorage.getItem("jobByHiringTeamMembers");
  const baseMembers = userDetailsData ? JSON.parse(userDetailsData) : [];
  const navigate = useNavigate();
  const [activeMessageType, setActiveMessageType] = useState(null);
  const [teams, setTeams] = useState(null);
  const dispatch = useAppDispatch();
  const [jobApplication1, setJobApplication1] = useState(null);
  const [selectedFilterHeader, setSelectedFilterHeader] = useState(null);
  const [isOpenHeader, setIsOpenHeader] = useState(true);
  const [pipelineStages, setPipelineStages] = useState([]);
  const [applicationList, setApplicationList] = useState([]);
  const optionsWithAllStagesHeader = [...pipelineStages];
  const currentCandidateData = applicationList.find(
    (candidate) => candidate.id === applicationId,
  );
  const currentIndexNo = currentCandidateData
    ? currentCandidateData.index_no
    : null;
  const [jobStatus, setJobStatus] = useState(null);
  const [isApplicationLoading, setIsApplicationLoading] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState({
    id: "all",
    department_name: "Select Department",
  });
  const [jobStatus1, setJobStatus1] = useState("");
  const [firstTab, setFirstTab] = useState(null);
  const loadingBarRef = useRef(null);

  function classNames(...classes: any) {
    return classes.filter(Boolean).join(" ");
  }

  // teams
  useEffect(() => {
    if (baseId) {
      const fetchTeams = async () => {
        const storedBase = localStorage.getItem("baseDepartmentData");
        if (storedBase) {
          setTeams(JSON.parse(storedBase));
        } else {
          try {
            const baseResponse = await dispatch(
              fetchDepartmentList(userDetails?.id || baseId),
            );
            setTeams(baseResponse.payload);
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchTeams();
    }
  }, [baseId, dispatch]);

  useEffect(() => {
    const storedData = localStorage.getItem("baseDepartmentData");
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        const departmentData = Array.isArray(parsedData?.data)
          ? parsedData?.data
          : [];
        const allOption = { id: "all", department_name: "Select Department" };
        setDepartments([allOption, ...departmentData]);
        setSelectedDepartment(allOption);
      } catch (error) {
        console.error("Error parsing department data:", error);
      }
    }
  }, []);

  const loadMoreActivities = async () => {
    if (allActivityItem.hasNextPage && !isLoading && shouldLoadMore) {
      setIsLoading(true);
      try {
        const nextPage = allActivityItem.currentPage + 1;
        let fullUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/${jobId}/application.list?page=${nextPage}&limit=${allActivityItem.limit}`;

        // department
        if (selectedDepartment && selectedDepartment !== "all") {
          fullUrl += `&job_department_id=${selectedDepartment.id}`;
        }

        const response = await _baseRequest(fullUrl, "GET");

        if (
          response.status === 200 &&
          response.data.jobApplication &&
          response.data.jobApplication.length > 0
        ) {
          setAllActivityItem((prevState) => ({
            ...response.data,
            jobApplication: [
              ...prevState.jobApplication,
              ...response.data.jobApplication,
            ],
          }));
        } else {
          setAllActivityItem((prevState) => ({
            ...prevState,
            hasNextPage: false,
          }));
        }
      } catch (error) {
        console.error("Error fetching more activities:", error);
      } finally {
        setIsLoading(false);
        setShouldLoadMore(false);
      }
    }
  };

  const debouncedHandleScroll = debounce(() => {
    if (listRef.current && allActivityItem.hasNextPage && !isLoading) {
      const { scrollTop, scrollHeight, clientHeight } = listRef.current;
      if (scrollHeight - scrollTop <= clientHeight * 1.5) {
        setShouldLoadMore(true);
      }
    }
  }, 200);

  useEffect(() => {
    if (shouldLoadMore) {
      loadMoreActivities();
    }
  }, [shouldLoadMore]);

  useEffect(() => {
    const fetchInitialData = async () => {
      let fullUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/${jobId}/application.list?page=1&limit=${allActivityItem.limit}`;

      // Add message type to the URL if a specific type is selected
      if (activeMessageType && activeMessageType !== "all") {
        fullUrl += `&type=${activeMessageType}`;
      }

      // Only add department filter if it's not "All"
      if (selectedDepartment && selectedDepartment.id !== "all") {
        fullUrl += `&job_department_id=${selectedDepartment.id}`;
      }

      try {
        setIsLoading(true);
        loadingBarRef.current.continuousStart();
        const response = await _baseRequest(fullUrl, "GET");

        if (
          response?.data?.jobApplication &&
          response?.data?.jobApplication?.length > 0
        ) {
          setAllActivityItem(response?.data);
          setActiveTab(response?.data?.jobApplication[0].id);
          setFirstTab(response?.data?.jobApplication[0]);
        } else {
          setAllActivityItem({
            jobApplication: [],
            totalJobPost: 0,
            currentPage: 1,
            hasNextPage: false,
            limit: 25,
            totalPages: 1,
          });
        }
      } catch (error) {
        console.error("Error fetching initial data:", error);
      } finally {
        setIsLoading(false);
        loadingBarRef.current.complete();
      }
    };

    if (baseId) {
      fetchInitialData();
    }
  }, [baseId, selected]);

  const handleToggleHeader = () => {
    setIsOpenHeader(!isOpenHeader);
  };

  useEffect(() => {
    let data = jobStatus?.stage_id;
    if (baseId) {
      const fetchJob = async () => {
        const storedBase = localStorage.getItem("jobPipelineStageData");
        if (storedBase) {
          const parsedData = JSON.parse(storedBase);
          if (parsedData && parsedData.stages) {
            setPipelineStages(parsedData.stages);
            setSelectedFilterHeader(
              parsedData.stages.find((stage) => stage.id == data),
            );
          }
        } else {
          try {
            const res = await dispatch(
              fetchJobPipelineDetailsData({
                baseId: Number(baseId),
                JobId: jobId,
              }),
            ).unwrap();
            if (res && res.data) {
              setPipelineStages(res?.data?.stages);
              localStorage.setItem(
                "jobPipelineStageData",
                JSON.stringify(res.data),
              );

              setSelectedFilterHeader(
                res?.data?.stages.find((stage) => stage.id == data),
              );
            }
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchJob();
    }
  }, [baseId, dispatch]);

  useEffect(() => {
    if (jobId && baseId) {
      const fetchJobDetails = async () => {
        const storedJobData = localStorage.getItem("jobPostDetailsData");

        if (storedJobData) {
          const parsedData = JSON.parse(storedJobData);

          // Check if the stored data matches the current jobId
          if (parsedData && parsedData.id === jobId) {
            setJobStatus(parsedData);

            // Handle stage selection from localStorage
            if (parsedData.stage_id) {
              const storedStageData = localStorage.getItem(
                "jobPipelineStageData",
              );
              if (storedStageData) {
                const parsedStageData = JSON.parse(storedStageData);
                if (parsedStageData && parsedStageData.stages) {
                  const matchingStage = parsedStageData.stages.find(
                    (stage) => String(stage.id) === String(parsedData.stage_id),
                  );
                  if (matchingStage) {
                    setSelectedFilterHeader(matchingStage);
                  } else if (parsedStageData.stages.length > 0) {
                    setSelectedFilterHeader(parsedStageData.stages[0]);
                  }
                }
              }
            }
            return;
          }
        }

        // If no valid cached data, fetch from API
        try {
          const res = await dispatch(
            fetchDocument({ baseId, id: jobId }),
          ).unwrap();
          if (res.status === 200) {
            // Store the fetched data in localStorage
            localStorage.setItem(
              "jobPostDetailsData",
              JSON.stringify(res.data),
            );
            setJobStatus(res.data);

            // Handle stage selection from fetched data
            if (res.data.stage_id) {
              const storedStageData = localStorage.getItem(
                "jobPipelineStageData",
              );
              if (storedStageData) {
                const parsedStageData = JSON.parse(storedStageData);
                if (parsedStageData && parsedStageData.stages) {
                  const matchingStage = parsedStageData.stages.find(
                    (stage) => String(stage.id) === String(res.data.stage_id),
                  );
                  if (matchingStage) {
                    setSelectedFilterHeader(matchingStage);
                  } else if (parsedStageData.stages.length > 0) {
                    setSelectedFilterHeader(parsedStageData.stages[0]);
                  }
                }
              }
            }
          }
        } catch (error) {
          console.error("Error fetching job data:", error);
        }
      };

      fetchJobDetails();
    }
  }, [dispatch, jobId, baseId]);

  // When you handle tab click and fetch application data
  const handleTabClick = async (item) => {
    try {
      setActiveTab(item.id);

      setActiveTab1(item);
      navigate(`/${baseId}/job/${jobId}/applications/app/${item?.id}`);

      if (item?.id) {
        setIsApplicationLoading(true);
        const res = await dispatch(
          fetchApplicationByListData({
            baseId,
            jobId: jobId,
          }),
        ).unwrap();

        setJobApplication1(res.data.jobApplication[0]);
        setApplicationList(res.data.jobApplication);

        // Check if job application contains stage_id
        if (res.data.jobApplication[0]?.stage_id) {
          const storedBase = localStorage.getItem("jobPipelineStageData");
          if (storedBase) {
            const parsedData = JSON.parse(storedBase);
            if (parsedData && parsedData.stages) {
              const matchingStage = parsedData.stages.find(
                (stage) =>
                  String(stage.id) ===
                  String(res.data.jobApplication[0].stage_id),
              );
              setSelectedFilterHeader(matchingStage || parsedData.stages[0]);
            }
          }
        }
      }
    } catch (error) {
      console.error("Error fetching application data:", error);
    } finally {
      setIsApplicationLoading(false);
    }
  };

  // Handle filter change
  const handleFilterChangeHeader = async (option) => {
    try {
      setSelectedFilterHeader(option);
      // Prepare payload
      const payload = {
        baseId,
        applicationId: applicationId,
        stage_id: option.id,
      };
      // Dispatch API call
      const res = await dispatch(UpdateJobApplicationByList(payload)).unwrap();
      if (res?.status === 200) {
        toast.success("Stage id updated successfully");
      }
    } catch (error) {
      console.error("Error updating job application list:", error);
    }
  };

  const handleLoadPrev = async () => {
    try {
      if (!currentCandidateData) return;
      const prevIndexNo = currentCandidateData.index_no - 1;
      if (prevIndexNo < 0) return;

      setIsApplicationLoading(true);

      const res = await dispatch(
        fetchApplicationByListData({
          baseId,
          jobId,
          page: prevIndexNo,
          limit: 1,
        }),
      ).unwrap();

      if (res.status === 200 && res.data.jobApplication.length > 0) {
        const prevCandidate = res.data.jobApplication[0];
        // setJobApplication1(prevCandidate);
        navigate(
          `/${baseId}/job/${jobId}/applications/app/${prevCandidate.id}`,
        );
      }
    } catch (error) {
      console.error("Error fetching previous candidate:", error);
    } finally {
      setIsApplicationLoading(false);
    }
  };

  const handleLoadNext = async () => {
    try {
      const currentCandidate = applicationList.find(
        (candidate) => candidate.id === applicationId,
      );

      if (!currentCandidate) return;

      const nextIndexNo = currentCandidate.index_no + 1;

      setIsApplicationLoading(true); // Set loading to true before fetch

      const res = await dispatch(
        fetchApplicationByListData({
          baseId,
          jobId,
          page: nextIndexNo,
          limit: 1,
        }),
      ).unwrap();

      if (res.status === 200 && res.data.jobApplication.length > 0) {
        const nextCandidate = res.data.jobApplication[0];
        navigate(
          `/${baseId}/job/${jobId}/applications/app/${nextCandidate.id}`,
        );
        // setJobApplication1(nextCandidate);
      }
    } catch (error) {
      console.error("Error fetching next candidate:", error);
    } finally {
      setIsApplicationLoading(false);
    }
  };

  // only fetch name job name
  useEffect(() => {
    if (jobId && baseId) {
      const fetchTeams = async () => {
        const storedBase = localStorage.getItem("jobPostDetailsData");
        if (storedBase) {
          setJobStatus1(JSON.parse(storedBase));
        } else {
          try {
            const baseResponse = await dispatch(
              fetchDocument({ baseId, id: jobId }),
            );
            setJobStatus1(baseResponse?.payload.data);
            localStorage.setItem(
              "jobPostDetailsData",
              JSON.stringify(baseResponse?.payload.data),
            );
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchTeams();
    }
  }, [dispatch, jobId, baseId]);

  const getShortFormTimeAgo = (createdAt) => {
    const timeAgo = formatDistanceStrict(new Date(createdAt), new Date(), {
      addSuffix: true,
      includeSeconds: true,
    });

    const shortFormTimeAgo = timeAgo
      .replace(/ hours?/, " hrs")
      .replace(/ minutes?/, " mins")
      .replace(/ seconds?/, " secs")
      .replace(/ days?/, " days")
      .replace(/ months?/, " mon")
      .replace(/ years?/, " yrs");

    const cleanedTimeAgo = shortFormTimeAgo
      .replace(/\sago$/, "")
      .replace(/^about\s/, "");

    return cleanedTimeAgo;
  };
  const handleApplicationDetails = (id) => {
    navigate(`/${baseId}/job/${jobId}/app/${id?.id}/overview`);
  };

  return (
    <div className="h-[calc(100vh_-62px)] flex justify-start items-start data-inbox-feedback ring-1 lg:ring-zinc-950/5 shadow-xs  rounded-tl-none rounded-tr-lg rounded-bl-none rounded-br-lg overflow-x-auto">
      <LoadingBar color="#ff591e" ref={loadingBarRef} />
      <div className="flex flex-1 flex-col min-w-0 h-full">
        <div className="flex  flex-row flex-1  overflow-y-hidden">
          <div
            className={`flex flex-col min-h-0 ${isSidebarOpen ? "mq767:min-w-full mq1023:min-w-[350px] mq3000:min-w-[350px]  mq767:max-w-full mq1023:max-w-[350px] mq3000:max-w-[350px]" : "min-w-0 max-w-0"} transition-all duration-300 ease-in-out`}
          >
            <div
              className="fixed top-0 sidebar-fixed sm:w-full"
              style={{ zIndex: 9 }}
            >
              <div className="flex items-center"></div>
            </div>
            <span className="h-[52px] pl-6 pr-3 flex items-center font-semibold text-sm">
              Applications
            </span>
            <div className="bg-[#e0e0e0] w-full h-[1px]"></div>
            <div
              ref={listRef}
              className={
                isHovered
                  ? "inbox-height-activity overflowing-element hovered flex-1 p-0 mt-[0px]"
                  : "inbox-height-activity overflowing-element mt-[0px]"
              }
              onMouseOver={handleMouseOver}
              onMouseOut={handleMouseOut}
              onScroll={debouncedHandleScroll}
            >
              <div className="m-auto min-h-full max-w-[80em]">
                <ul className=" max-w-full md:max-w-[343px] lg:max-w-[343px] h-full p-[8px]">
                  {isLoading && jobApplication.length === 0 ? (
                    <div className="flex items-center justify-center w-full h-[calc(100vh_-_75px)]">
                      <div className="simple-spinner-loader">
                        <span></span>
                      </div>
                    </div>
                  ) : (
                    // Your existing list rendering code
                    jobApplication.map((item, index) => {
                      const cleanedTimeAgo = getShortFormTimeAgo(
                        item.created_at,
                      );

                      return (
                        <div className="" key={index}>
                          <div className="sm:block hidden">
                            <li
                              key={item.id}
                              className="flex flex-row items-center justify-between text-sm p-0"
                              onClick={() => handleTabClick(item)}
                            >
                              <div
                                className={`flex flex-row items-center justify-between flex-1 rounded-[0.375rem] mb-1 cursor-pointer px-2 py-3 hover:bg-gray-100 ${item.id === (applicationId || activeTab1?.id || activeTab) ? "bg-gray-100" : "bg-transparent"}`}
                              >
                                <div className="px-2 w-full h-full gap-2 flex flex-col gap-y-1">
                                  <div className="flex items-center flex-row gap-2 justify-between">
                                    <div className="line-clamp-1 text-[13px] text-[#000000EB] capitalize font-medium">
                                      {item.app_name}
                                    </div>
                                    {item?.reviewed_by === null && (
                                      <span
                                        className="flex items-center gap-[6px]  text-[13px] capitalize  rounded-md bg-gray-50 px-2 py-1 
                                     text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10"
                                      >
                                        New
                                      </span>
                                    )}
                                  </div>
                                  <div className="flex items-center flex-row gap-2">
                                    <div className=" text-[#000000EB] overflow-hidden text-ellipsis font-normal line-clamp-1 text-[13px]">
                                      {item.app_headline || item.app_email}
                                    </div>
                                    <span
                                      dateTime={item.msg_created_at}
                                      className="text-dark-black-200 text-[13px] flex-shrink-0 ml-auto"
                                    >
                                      {cleanedTimeAgo}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </div>
                        </div>
                      );
                    })
                  )}

                  {isLoading && jobApplication.hasNextPage && (
                    <div className=" flex items-center justify-center relative z-50 h-[25px]">
                      <div className="simple-spinner-loader">
                        <span></span>
                      </div>
                    </div>
                  )}
                  {!isLoading && jobApplication.hasNextPage && (
                    <p className="text-center my-4 text-[12px] text-gray-500">
                      No more results.
                    </p>
                  )}
                  {!isLoading &&
                    !jobApplication.hasNextPage &&
                    jobApplication.length === 0 && (
                      <div
                        className="w-full mt-0 flex justify-center items-center flex-col gap-y-3"
                        style={{ height: "calc(100vh - 75px)" }}
                      >
                        <ExclamationIcon />
                        <p className="text-[#0000007a] text-[13px]">
                          Nothing here
                        </p>
                      </div>
                    )}
                </ul>
              </div>
            </div>
          </div>
          <div className=" border-l border-b-0 border-gray-200 w-full border-t-0 mt-[0px] min-w-[800px]">
            <div className=" shrink-0 items-center gap-x-4 bg-white px-4 border-b border-solid border-[#e0e0e0] h-[53px] sm:gap-x-6 sm:px-6 lg:px-4 rounded-tr-lg">
              <div className="flex items-center mx-2 gap-2 py-2 justify-between">
                <div className="flex items-center gap-x-2">
                  {activeTab1 ? (
                    <>
                      <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-none text-[0.625rem] font-medium text-white capitalize bg-gray-400">
                        {activeTab1?.app_name?.charAt(0) ||
                          activeTab1?.app_email?.charAt(0)}
                      </div>
                      <div className="flex flex-col gap-y-[1px]">
                        <span className="text-black-100 font-semibold text-sm capitalize line-clamp-1">
                          {activeTab1?.app_name}
                        </span>
                        <span className="text-[#1b1b1b] leading-4 text-[12px] font-normal line-clamp-1 w-[255px]">
                          {activeTab1?.app_headline || activeTab1?.app_email}
                        </span>
                      </div>
                    </>
                  ) : (
                    firstTab && (
                      <>
                        <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-none text-[0.625rem] font-medium text-white capitalize bg-gray-400">
                          {firstTab?.app_name?.charAt(0) ||
                            firstTab?.app_email?.charAt(0)}
                        </div>
                        <div className="flex flex-col gap-y-[1px]">
                          <span className="text-black-100 font-semibold text-sm capitalize line-clamp-1">
                            {firstTab?.app_name}
                          </span>
                          <span className="text-[#1b1b1b] leading-4 text-[12px] font-normal line-clamp-1 w-[255px]">
                            {firstTab?.app_headline || firstTab?.app_email}
                          </span>
                        </div>
                      </>
                    )
                  )}
                </div>
                <div className="flex items-center gap-x-2">
                  <button
                    onClick={() =>
                      handleApplicationDetails(
                        activeTab1 ? activeTab1 : firstTab,
                      )
                    }
                    className="rounded-md  duration-200 font-[600] text-[0.8125rem] h-[32px] w-[32px] flex items-center justify-center border border-solid border-[#e7e7e8]"
                    style={{
                      transitionProperty:
                        "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                      data-slot="icon"
                      className="w-[1.1em] h-[1.1em] text-[#000]"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
                      />
                    </svg>
                  </button>
                  {jobApplication1?.stage_id && (
                    <div className="ml-auto">
                      <div className="flex items-center gap-x-4">
                        <div
                          data-title="Change Stage"
                          className="max-w-[140px] min-w-[140px] w-full table-tooltip before:!bottom-[-32px] before:!left-[54px]"
                        >
                          <div
                            onClick={handleToggleHeader}
                            className=" w-full inline-flex items-center justify-start whitespace-nowrap rounded-lg text-sm font-medium transition-colors outline-offset-2
focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50 
[&_svg]:pointer-events-none [&_svg]:shrink-0 border border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-8 px-2  py-2"
                          >
                            <Listbox
                              value={selectedFilterHeader}
                              onChange={handleFilterChangeHeader}
                            >
                              <div className="relative mt-0 w-full">
                                <ListboxButton className="relative w-full bg-transparent flex items-center justify-between p-0 cursor-pointer rounded-md text-left text-gray-900 border-none">
                                  <div className="flex items-center gap-x-[6px]">
                                    {selectedFilterHeader?.stage_colour && (
                                      <span
                                        className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] 
          border-none text-[0.625rem] font-medium text-white capitalize"
                                        style={{
                                          background:
                                            selectedFilterHeader?.stage_colour,
                                        }}
                                      ></span>
                                    )}
                                    {selectedFilterHeader?.stage_name && (
                                      <span className="block truncate text-[#1b1b1b] font-normal">
                                        {selectedFilterHeader?.stage_name}
                                      </span>
                                    )}
                                  </div>

                                  <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-down w-[1rem] h-[1rem] text-[#808080]"
                                    >
                                      <path
                                        stroke="none"
                                        d="M0 0h24v24H0z"
                                        fill="none"
                                      />
                                      <path d="M6 9l6 6l6 -6" />
                                    </svg>
                                  </span>
                                </ListboxButton>

                                <ListboxOptions className="absolute z-10 mt-[9px] left-[-17px] bg-white max-w-[140px] min-w-[140px] w-full overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ">
                                  {optionsWithAllStagesHeader.map((option) => (
                                    <ListboxOption
                                      key={option.id}
                                      value={option}
                                      className={({ active }) =>
                                        classNames(
                                          active
                                            ? "bg-gray-200 text-[#1d2025]"
                                            : "text-gray-900",
                                          "relative flex select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 cursor-pointer",
                                        )
                                      }
                                    >
                                      {({ selected, active }) => (
                                        <>
                                          <div className="flex items-center justify-between">
                                            <div className="flex items-center gap-x-[6px]">
                                              <span
                                                className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] 
                border-none text-[0.625rem] font-medium text-white capitalize"
                                                style={{
                                                  background:
                                                    option?.stage_colour,
                                                }}
                                              ></span>
                                              <span
                                                className={classNames(
                                                  selected
                                                    ? "font-semibold"
                                                    : "font-normal",
                                                  "block truncate",
                                                )}
                                              >
                                                {option.stage_name}
                                              </span>
                                            </div>
                                          </div>
                                          {selected ? (
                                            <span
                                              className={classNames(
                                                active
                                                  ? "text-white"
                                                  : "text-gray-600",
                                                "absolute inset-y-0 right-0 flex items-center pr-4",
                                              )}
                                            ></span>
                                          ) : null}
                                        </>
                                      )}
                                    </ListboxOption>
                                  ))}
                                </ListboxOptions>
                              </div>
                            </Listbox>
                          </div>
                        </div>

                        <div className="flex items-center gap-x-2">
                          <button
                            data-title={currentIndexNo}
                            onClick={handleLoadPrev}
                            disabled={currentIndexNo === 1}
                            className={`table-tooltip before:!bottom-[-32px] before:!left-[2px] before:!right-auto before:!translate-x-0
 relative inline-flex hover:bg-[#f4f4f5] items-center justify-center whitespace-nowrap rounded-lg text-sm font-medium transition-colors 
outline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none
 [&_svg]:shrink-0 border border-input bg-background
 shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-8 w-8 ${currentIndexNo === 1 ? "cursor-not-allowed" : "hover:bg-[#f4f4f5]"}`}
                          >
                            <span className="sr-only">Previous</span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-narrow-left w-[1rem] h-[1rem] text-[#808080]"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path d="M5 12l14 0" />
                              <path d="M5 12l4 4" />
                              <path d="M5 12l4 -4" />
                            </svg>
                          </button>
                          <button
                            onClick={handleLoadNext}
                            data-title={currentIndexNo + 1}
                            disabled={currentIndexNo === applicationList.length}
                            className={`table-tooltip before:!bottom-[-32px] before:!left-[2px] before:!right-auto before:!translate-x-0 relative inline-flex hover:bg-[#f4f4f5] items-center justify-center whitespace-nowrap rounded-lg text-sm font-medium transition-colors 
outline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none
 [&_svg]:shrink-0 border border-input bg-background
 shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground
  h-8 w-8 ${currentIndexNo === applicationList.length ? " cursor-not-allowed" : "hover:bg-[#f4f4f5]"}`}
                          >
                            <span className="sr-only">Next</span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-narrow-right w-[1rem] h-[1rem] text-[#808080]"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path d="M5 12l14 0" />
                              <path d="M15 16l4 -4" />
                              <path d="M15 8l4 4" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="flex-1 flex flex-col py-[34px] lg:py-[28px] px-0 lg:px-10 overflow-auto h-[calc(100vh_-_120px)]">
              <div className="px-[2px] sm:px-6 lg:px-8 w-full">
                <div className="max-w-full md:max-w-[710px] lg:max-w-[710px] m-auto">
                  {isLoading || isApplicationLoading ? (
                    <div
                      className="flex items-center justify-center w-full"
                      style={{ height: "calc(100vh - 150px)" }}
                    >
                      <div className="simple-spinner-loader">
                        <span></span>
                      </div>
                    </div>
                  ) : // empty state
                  !jobApplication?.length ? (
                    <div
                      className="w-full mt-0 flex justify-center items-center flex-col gap-y-3"
                      style={{ height: "calc(100vh - 150px)" }}
                    >
                      <ExclamationIcon />
                      <p className="text-[#0000007a] text-[13px]">
                        Nothing here
                      </p>
                    </div>
                  ) : (
                    <ApplicationData
                      jobApplication={jobApplication}
                      job={activeTab}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Application;
